import { IState } from "..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../app/store";
import { initialServiceCentersState } from "./ServiceCentersState";
import TrackingService from "../../app/data/tracking/trackingService";
import TerminalSummaryService from "../../app/data/terminal-summary/terminalsummaryService";
import { ServiceCentersRequestModel } from "../../app/data/tracking/ServiceCentersModel";

const trackingService = TrackingService.getInstance();
const terminalSummaryService = TerminalSummaryService.getInstance();

export const serviceCentersSlice = createSlice({
  name: "serviceCenters",
  initialState: initialServiceCentersState,
  reducers: {
    resetServiceCenters: (state) => initialServiceCentersState,
    serviceCentersLoadingStarted: (state) => {
      state.loading = true;
      state.loadingFailed = false;
      state.loaded = false;
    },
    serviceCentersLoadingSucceed: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
      state.origins = payload.origins;
      state.destinations = payload.destinations;
    },
    serviceCentersRegionsLoadingSucceed: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
      state.regions = payload; // this is just the array from API
    },
    serviceCentersLoadingFailed: (state) => {
      state.loading = false;
      state.loadingFailed = true;
      state.origins = [];
      state.destinations = [];
    },
  },
});

export const {
  resetServiceCenters,
  serviceCentersLoadingStarted,
  serviceCentersLoadingSucceed,
  serviceCentersRegionsLoadingSucceed,
  serviceCentersLoadingFailed,
} = serviceCentersSlice.actions;

export const serviceCentersSelector = (state: IState) => state.serviceCenters;

export const getServiceCenters = (params?: ServiceCentersRequestModel
): AppThunk => async (dispatch) => {
  dispatch(serviceCentersLoadingStarted());

  const response = await trackingService.getServiceCenters(params);

  if (response.ok()) {
    dispatch(serviceCentersLoadingSucceed(response.data));
  } else {
    dispatch(serviceCentersLoadingFailed());
  }
};

export const getRegionsServiceCenters = (): AppThunk => async (dispatch) => {
  dispatch(serviceCentersLoadingStarted());

  const response = await terminalSummaryService.getRegionsServiceCenters();

  if (response.ok()) {
    dispatch(serviceCentersRegionsLoadingSucceed(response.data));
  } else {
    dispatch(serviceCentersLoadingFailed());
  }
};

const serviceCentersReducer = serviceCentersSlice.reducer;
export default serviceCentersReducer;
